import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import domainService from "../../services/domain.service";

export const getDetailSubDomains = createAsyncThunk(
  "domain/getDetailSubDomains",
  async (data, { rejectWithValue }) => {
    try {
      return await domainService.getDetailSubDomains(data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailIps = createAsyncThunk(
  "domain/getDetailIps",
  async (data, { rejectWithValue }) => {
    try {
      return await domainService.getDetailIps(data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  subDomains: null,
  ips: null,
  detailSubdomainsLoading: false,
  detailIpsLoading: false,
};

export const pdfSlice = createSlice({
  name: "pdfSlice",
  initialState,
  reducers: {
    clearDetailPdfDatas: (state) => {
      state.subDomains = null;
      state.ips = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDetailSubDomains.fulfilled, (state, action) => {
        console.log(action);
        
        state.subDomains = action.payload.data;
        state.detailSubdomainsLoading = false;
      })
      .addCase(getDetailSubDomains.rejected, (state) => {
        state.detailSubdomainsLoading = false;
      })
      .addCase(getDetailSubDomains.pending, (state) => {
        state.detailSubdomainsLoading = true;
        state.subDomains = [];
      })
      .addCase(getDetailIps.fulfilled, (state, action) => {
        console.log(action);
        
        state.ips = action.payload.data;
        state.detailIpsLoading = false;
      })
      .addCase(getDetailIps.rejected, (state) => {
        state.detailIpsLoading = false;
      })
      .addCase(getDetailIps.pending, (state) => {
        state.detailIpsLoading = true;
        state.ips = [];
      });
  },
});

export const { clearDetailPdfDatas } = pdfSlice.actions;

export default pdfSlice.reducer;
